export const ENDPOINT = '/api/me/life';
